module.exports = __webpack_public_path__ + "static/img/mitad.a19cc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/mitad.png
// module id = 238
// module chunks = 1